import React, { useEffect } from 'react'
import _ from 'lodash'
import { useIntl } from 'react-intl'
import { Fieldset, Group } from '@mantine/core'
import LabeledCheckbox from '../../../../components/common/form-components/labeled-checkbox/LabeledCheckbox'

import './centerForm.scss'
import LabeledCalendar from '../../../../components/common/form-components/labeled-calendar/LabeledCalendar'
import LabeledNumber from '../../../../components/common/form-components/labeled-inputs/LabeledNumber'
import LabeledText from '../../../../components/common/form-components/labeled-inputs/LabeledText'
import {
  ACTIVITY_TYPES,
  ACTIVITY_TYPES_ENUM,
} from '../../../../utils/constants/activityTypes'
import AppContainer from '../../../../component/layout/AppContainer.tsx'
import AppSimpleGrid from '../../../../component/layout/AppSimpleGrid.tsx'
import AppCheckbox from '../../../../component/form/AppCheckbox.tsx'
import AppInput from '../../../../component/form/AppInput.tsx'
import AppDateInput from '../../../../component/form/AppDateInput.tsx'
import AppNumberInput from '../../../../component/form/AppNumberInput.tsx'
import AppIcon from '../../../../component/common/AppIcon.tsx'

const CenterServicesForm = ({
  centerId,
  activityType,
  inputs,
  onChangeInputs,
  updateInputs,
}) => {
  const { formatMessage: msg } = useIntl()

  useEffect(() => {}, [])

  const handleServiceTypeChange = (e) => {
    const { name, value } = e.target

    if (inputs?.services?.serviceTypeIds?.includes(name)) {
      updateInputs({
        ...inputs,
        services: {
          ...inputs?.services,
          serviceTypeIds: inputs?.services?.serviceTypeIds?.filter(
            (id) => id !== name,
          ),
        },
      })
    } else {
      updateInputs({
        ...inputs,
        services: {
          ...inputs?.services,
          serviceTypeIds: [...(inputs?.services?.serviceTypeIds || []), name],
        },
      })
    }
  }

  const handleWashTypeChange = (e) => {
    const { name, value } = e.target

    if (inputs?.washServices?.washingTypeIds?.includes(name)) {
      updateInputs({
        ...inputs,
        washServices: {
          ...inputs?.washServices,
          // washingTypeIds: inputs?.washServices?.washingTypeIds?.filter((id) => id !== name)
          washingTypeIds: inputs?.washServices?.washingTypeIds?.filter(
            (id) => id !== name,
          ),
        },
      })
    } else {
      updateInputs({
        ...inputs,
        washServices: {
          ...inputs?.washServices,
          // washingTypeIds: [...(inputs?.washServices?.washingTypeIds || []), name]
          washingTypeIds: [
            ...(inputs?.washServices?.washingTypeIds || []),
            name,
          ],
        },
      })
    }
  }

  return (
    <AppSimpleGrid cols={1}>
      <AppContainer>
        <AppSimpleGrid cols={6}>
          <AppCheckbox
            entity="computer"
            size="lg"
            label={msg({ id: 'computer' })}
            name="pc"
            onChange={onChangeInputs}
            checked={inputs?.pc}
          />
          <AppCheckbox
            entity="internet"
            size="lg"
            label={msg({ id: 'ethernet' })}
            name="internet"
            onChange={onChangeInputs}
            checked={inputs?.internet}
          />
          <AppNumberInput
            type="year"
            label="automatonInstallYear"
            name="automatonInstallYear"
            value={inputs?.automatonInstallYear}
            onChange={onChangeInputs}
          />
          <AppInput
            label="automatonBrand"
            name="automatonBrand"
            value={inputs?.automatonBrand}
            onChange={onChangeInputs}
          />
          <AppNumberInput
            type="year"
            label="solarPanelInstallYear"
            name="solarPanelInstallYear"
            value={inputs?.solarPanelInstallYear}
            onChange={onChangeInputs}
          />
          <AppInput
            label="solarPanelBrand"
            name="solarPanelBrand"
            value={inputs?.solarPanelBrand}
            onChange={onChangeInputs}
          />
        </AppSimpleGrid>

        {(activityType === ACTIVITY_TYPES_ENUM.WASHES ||
          activityType === ACTIVITY_TYPES_ENUM.SERVICES_AND_WASHES) && (
          <Fieldset legend={msg({ id: 'wash' })} mt="xl">
            <AppSimpleGrid cols={6}>
              <AppDateInput
                label="startUpDate"
                required
                name="washServices.startUpDate"
                value={inputs?.washServices?.startUpDate}
                onChange={onChangeInputs}
              />
              <AppNumberInput
                type="quantity"
                label="numTrackDiscovered"
                name="washServices.numTrackDiscovered"
                onChange={onChangeInputs}
                value={inputs?.washServices?.numTrackDiscovered}
                checked={inputs?.washServices?.numTrackDiscovered}
              />
              <AppNumberInput
                type="quantity"
                label="numTrackCovered"
                name="washServices.numTrackCovered"
                onChange={onChangeInputs}
                value={inputs?.washServices?.numTrackCovered}
                checked={inputs?.washServices?.numTrackCovered}
              />
              <AppNumberInput
                type="quantity"
                label="numVacuumCleaners"
                name="washServices.numVacuumCleaners"
                onChange={onChangeInputs}
                value={inputs?.washServices?.numVacuumCleaners}
                checked={inputs?.washServices?.numVacuumCleaners}
              />
            </AppSimpleGrid>
            <AppSimpleGrid cols={6}>
              {inputs?.washServices?.washingTypes?.map((service) => (
                <AppCheckbox
                  size="lg"
                  key={service?._id}
                  label={service?.name}
                  name={service?._id}
                  onChange={handleWashTypeChange}
                  checked={inputs?.washServices?.washingTypeIds?.includes(
                    service?._id,
                  )}
                />
              ))}
            </AppSimpleGrid>
          </Fieldset>
        )}

        {(activityType === ACTIVITY_TYPES_ENUM.SERVICES ||
          activityType === ACTIVITY_TYPES_ENUM.SERVICES_AND_WASHES) && (
          <Fieldset legend={msg({ id: 'services' })} mt="xl">
            <AppSimpleGrid cols={4}>
              <AppDateInput
                label="startUpDate"
                name="services.startUpDate"
                value={inputs?.services?.startUpDate}
                onChange={onChangeInputs}
              />
              <AppNumberInput
                type="quantity"
                label="numTracks"
                name="services.numTracks"
                onChange={onChangeInputs}
                value={inputs?.services?.numTracks}
                checked={inputs?.services?.numTracks}
              />
              <AppNumberInput
                type="quantity"
                label="numDispensers"
                name="services.numDispensers"
                onChange={onChangeInputs}
                value={inputs?.services?.numDispensers}
                checked={inputs?.services?.numDispensers}
              />
              <AppNumberInput
                type="quantity"
                label="numAutoFuel"
                name="services.numAutoFuel"
                onChange={onChangeInputs}
                value={inputs?.services?.numAutoFuel}
                checked={inputs?.services?.numAutoFuel}
              />
            </AppSimpleGrid>
            <AppSimpleGrid cols={6}>
              {inputs?.services?.servicesTypes?.map((service) => (
                <AppCheckbox
                  size="lg"
                  key={service?._id}
                  label={service?.name}
                  name={service?._id}
                  onChange={handleServiceTypeChange}
                  checked={inputs?.services?.serviceTypeIds?.includes(
                    service?._id,
                  )}
                />
              ))}
            </AppSimpleGrid>
          </Fieldset>
        )}
      </AppContainer>
    </AppSimpleGrid>
  )
}

export default CenterServicesForm
